import React from "react";
import { Hero } from "@/components/portfolio/Hero";
import { AssistantInput } from "@/components/portfolio/AssistantInput";
import { LogoShowcase } from "@/components/portfolio/LogoShowcase";
import { AppMenu } from "@/components/navigation/AppMenu";
import awsLogo from "@/assets/images/aws.svg";
import goLogo from "@/assets/images/go.svg";
import kthLogo from "@/assets/images/kth.svg";
import northvoltLogo from "@/assets/images/northvolt.svg";
import opcuaLogo from "@/assets/images/opcua.svg";
import rancherLogo from "@/assets/images/rancher.svg";
// import bombardierLogo from "@/assets/images/bombardier.svg";
// import shireLogo from "@/assets/images/shire.svg";

const Index = () => {
  // Portfolio data
  const portfolioData = {
    name: "Anthony Clerc",
    description:
      "Passionate about the green transition and sustainable technology, I continuously seek to expand my skills and embrace innovation. As a Software Tech Lead with 6+ years of experience, I specialize in industrial connectivity, factory digitalization, and large-scale system integration.",
  };

  // Logo data (updated to use SVG files from assets/images)
  const logos = [
    {
      src: opcuaLogo,
      alt: "OPC UA",
      invertColors: true,
      width: "14rem",
    },
    {
      src: goLogo,
      alt: "GO",
      invertColors: true,
      width: "7rem",
    },
    {
      src: rancherLogo,
      alt: "RANCHER",
      invertColors: true,
      isWide: true,
      width: "15rem",
    },
    {
      src: awsLogo,
      alt: "AWS",
      invertColors: true,
      width: "6rem",
    },
    {
      src: northvoltLogo,
      alt: "Northvolt",
      isWide: true,
      invertColors: true,
      width: "15rem",
    },
    {
      src: kthLogo,
      alt: "KTH",
      invertColors: true,
      width: "6rem",
    },
    // {
    //   src: bombardierLogo,
    //   alt: "Bombardier",
    //   invertColors: true,
    //   width: "18rem",
    // },
    // {
    //   src: shireLogo,
    //   alt: "Shire",
    //   invertColors: true,
    //   width: "8rem",
    // },
  ];

  return (
    <main className="flex flex-col items-center min-h-screen w-full bg-gradient-to-b from-[#D5ED5C] to-[#28B88F] px-5 py-10">
      {/* Google Fonts - Inter */}
      <link
        href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap"
        rel="stylesheet"
      />
      
      {/* App Menu - positioned absolutely in the top-right corner */}
      <div className="absolute top-4 right-4 z-50">
        <AppMenu />
      </div>

      {/* Hero Section */}
      <Hero name={portfolioData.name} description={portfolioData.description} />
      
      {/* Assistant Input with higher z-index */}
      <AssistantInput />

      {/* Position the logo showcase behind with pointer-events disabled */}
      <LogoShowcase logos={logos} />
    </main>
  );
};

export default Index;
